// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInCreateNewAccountStyles } from "@stoneage/Overrides/Widgets/SignIn/SignInCreateNewAccount";
import { fontConfig } from "@stoneage/XDL/constants";
import { color, xScreen } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

signInCreateNewAccountStyles.signInCreateNewAccountWrapper = {
    css: css`
        padding-left: 16px;
        ${xScreen("lt", "sm")} {
            border-top: 1px solid ${color("common.ui19")};
            padding-top: 16px;
            padding-left: 0;
        }
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountTitle = {
    variant: "h3",
    css: css`
        text-align: center;
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountText = {
    ...fontConfig.regular,
    css: css`
        display: block;
        width: 100%;
        text-align: center;
        margin-bottom: 16px;
        ${xScreen("lt", "sm")} {
            padding: 0;
        }
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountActions = {
    css: css`
        display: flex;
        justify-content: center;
    `,
};
